<template>
  <div>
    <div v-if="!viewText">
      <subPartnerLink
        :subPartners="[subPartner]"
        :partners="partners"
        :viewPartner="true"
        :searchBar="false"
        :itemsPerPage="10"
        @getSubPartners="getSubPartners"
      />
    </div>
    <div class="pt-4" v-if="!viewText || viewText == 'Branches'">
      <div v-if="!viewText" class="ml-4 pl-4">
        <h2>Branches</h2>
      </div>
      <partnerBranch
        :partnerId="partnerId"
        :subPartnerId="subPartnerId"
        :partners="partners"
        :subPartners="subPartners"
        :partnerBranches="partnerBranches"
        :viewPartner="true"
        :viewSubPartner="true"
        :itemsPerPage="itemsPerPage"
        @viewMore="viewMore"
        @getSubPartners="getSubPartners"
        @getpartnerBranchesBySubPartnerId="getpartnerBranchesBySubPartnerId"
      />
    </div>
  </div>
</template>

<script>
import partnerBranch from "@/components/link/branch.vue";
import subPartnerLink from "@/components/link/subPartner.vue";

export default {
  components: {
    partnerBranch,
    subPartnerLink,
  },
  data() {
    return {
      partnerBranches: [],
      subPartners: [],
      partners: [],
      subPartnerId: null,
      partnerId: null,
      itemsPerPage: 5,
      subPartner: {},
      viewText: null,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.subPartnerId = Number(this.$route.params?.id);
    this.initialise();
  },
  methods: {
    viewMore(value) {
      this.$router.push({
        name: "View Sub Partner Code",
        params: { id: this.subPartnerId, code: value },
      });
    },
    async initialise() {
      await this.getpartnerBranchesBySubPartnerId();
      await this.getSubPartners();
      await this.getPartners();
    },
    async getpartnerBranchesBySubPartnerId() {
      await this.$axios
        .get("partner_branches", {
          params: { sub_partner_id: this.subPartnerId },
        })
        .then((res) => {
          this.partnerBranches = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getSubPartners(partner_id) {
      await this.$axios
        .get("sub_partners", { params: { partner_id } })
        .then((res) => {
          this.subPartners = res.data.data;
          this.subPartner = this.subPartners.find(
            (item) => item.id == this.subPartnerId
          );

          const crumbs = [
            { text: "Sub Partners", to: { name: "Sub Partners" } },
            {
              text: this.subPartner.name,
              to: { path: `/sub_partner/branches/${this.subPartnerId}` },
            },
          ];
          if (
            this.$route.params?.code &&
            ["Branches"].includes(this.$route.params.code)
          ) {
            this.viewText = this.$route.params.code;
            this.itemsPerPage = -1;
            crumbs.push({ text: this.$route.params.code });
          } else {
            crumbs[crumbs.length - 1].to = undefined;
          }
          this.$store.commit("setBreadcrumbs", crumbs);

          this.partnerId = this.subPartner.partner_id;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
